<template>
  <div class="pdp-wrap">
    <Breadcrumb :config="{items: navItems}" />
    <div class="m-product-details__main">
      <div class="layout clearfix">
        <div class="ms-row row-collapsed">
        <div class="col-xs-12 col-md-8 float-left detail-left">
          <div class="primary-images m-product-details__primary-images">
            <div class="carousel slide">
              <template v-if="kvImages && kvImages.length">
                <PDPSwiper :items="kvImages" @slideChangeTransitionStart="onSwiperChange" />
              </template>
              <!-- 直播信息 -->
              <div class="live-content"  v-if="liveInfo.is_on === 1">
                <div class="icon_content" @click="handleGoWmpDetail">
                  <img class="icon" :style="liveStyle" :src="isMobile ? liveInfo.icon : liveInfo.pc_icon" alt="">
                </div>
                <div class="live-code" :style="{top: `${parseFloat(liveInfo.height) + 10}px`}">
                    <div class="code-img">
                      <canvas class="canvas" ref="qrcodeCanvas"> </canvas>
                    </div>
                    <div class="code-tip">扫码进入直播间</div>
                </div>
              </div>
            </div>
            <!-- 收藏 -->
            <div class="m-product-details__wishlist-btn animated delay-250 fadeIn" v-if="detailInfo && enableFav" @click="toggleFav">
              <button class="c-button c-button--icon add-to-wish-list">
                <svg v-if="isCollected" class="svg-inline icon-heart-full" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                  <path fill="#000" fill-rule="evenodd" stroke="#0D0D0D" d="M11.875 1C10.57 1 9.317 1.662 8.5 2.708 7.683 1.662 6.43 1 5.125 1 2.815 1 1 2.978 1 5.496c0 3.09 2.55 5.608 6.413 9.433L8.5 16l1.087-1.079C13.45 11.104 16 8.586 16 5.496 16 2.978 14.185 1 11.875 1z" />
                </svg>
                <svg v-else class="svg-inline icon-heart-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                  <path fill="none" fill-rule="evenodd" stroke="#0D0D0D" d="M11.875 1C10.57 1 9.317 1.662 8.5 2.708 7.683 1.662 6.43 1 5.125 1 2.815 1 1 2.978 1 5.496c0 3.09 2.55 5.608 6.413 9.433L8.5 16l1.087-1.079C13.45 11.104 16 8.586 16 5.496 16 2.978 14.185 1 11.875 1z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4 m-product-details__main-info float-left" v-if="detailInfo.product_name">
          <div :class="['info-box', skuOptions ? 'dialog__show' : '', infoPos ]">
            <!-- <div class="show-for-md m-product-details__badges">
              <div class="c-product-tile__badge">
                <span
                  class="c-product-tile__badge-item"
                  style="background-color: #fff; color: #000000; border-color: #CACACA"
                >Nouveauté</span>
              </div>
            </div>-->
            <div v-if="pdpCoupns.length" class="pdp-coupons" @click="handleOpenCouponList">
              <div class="ul">
                <div class="li" v-for="(item, index) in pdpCoupns" :key="index">{{ item.display_name || item.name }}</div>
              </div>
              <div class="icon">
                <i class="iconfont" style="transform: rotate(90deg);">&#xe636;</i>
              </div>
            </div>
            <h1 class="product-name m-product-details__product-name zh">
              {{detailInfo.product_name}}
              <template v-if="type == 'color' && currentSKUItems[0]">{{currentSKUItems[0].spec_desc}}</template>
            </h1>
            <h2 class="product-name_en m-product-details__product-name en" v-if="detailInfo.product_name_en">{{detailInfo.product_name_en}}</h2>
            <h2 class="m-product-details__description-short pdp__desc">{{ detailInfo.product_desc || detailInfo.short_product_desc }}</h2>
            <!-- capacity_ml & capacity_g -->
            <div class="m-product-details__selected-capacity" v-if="(type=='capacity_ml'||type=='capacity_g') && currentSKUItems && currentSKUItems[0]">
              容量：<span class="m-product-details__selected-value">{{currentSKUItems[0].spec_desc}}</span>
            </div>
            <!-- color: 下拉框 -->
            <div class="m-product-details__selected-capacity" v-if="type=='color'">
              <div class="c-select" @click="toggleSKUOptions(0, type)">
                <!-- <input v-model="" type="text" placeholder="口红色号" /> -->
                <div class="slect-color" v-if="currentSKUItems[0]">
                  <div class="color-value" :style="{background: `#${currentSKUItems[0].spec_property}`}"></div>
                  <div>{{currentSKUItems[0].spec_desc}}</div>
                </div>
                <div class="slect-color" v-else>
                  <div style="color: #999;">请选择产品色号</div>
                </div>
                <i class="iconfont" style="transform: rotate(90deg);">&#xe636;</i>
              </div>
              <div class="color-list aaa" v-show="showSKUOptions[0]">
                <VueScroll :ops="vsOpts">
                  <ul>
                    <li class="color-li" @click="toSwitchSKU(index, 0)" v-for="(skuItem,index) in detailInfo.skus" :key="index">
                      <div :class="['m-product-details__swatch',(fakeSKUIndex[0]==index || (fakeSKUIndex[0] == -1 && realSKUIndex[0] == index)) ?'selected':'']">
                        <span class="m-product-details__swatch-circle" :style="{background: `#${skuItem.spec_property}`}"></span>
                      </div>
                      <span>{{ skuItem.spec_desc}}</span>
                    </li>
                  </ul>
                </VueScroll>
              </div>
            </div>
            <!-- 常规商品SKU选择区域 -->
            <template v-if="(type =='capacity_ml' || type == 'capacity_g' || type == 'color') && detailInfo && detailInfo.skus.length > 1">
              <div class="attribute m-product-details__variation-attribute">
                <!-- SKU: capacity_g || capacity_ml -->
                <div v-if="type=='capacity_g'||type=='capacity_ml'" class="m-product-details__variation-non-swatchable">
                  <ul>
                    <li
                      :class="['capacity-value','m-product-details__variation-item',(fakeSKUIndex[0]==index || (fakeSKUIndex[0] == -1 && realSKUIndex[0] == index)) ? 'selected' : '']"
                      v-for="(item,index) in detailInfo.skus" :key="index"
                      @click="toSwitchSKU(index, 0)"
                    >{{`${item.spec_desc}`}}</li>
                  </ul>
                </div>
                <!-- SKU: color -->
                <div v-if="type=='color'" class="ms-row">
                  <ul class="m-product-details__color-swatches show-for-sm col-xs-12">
                    <li
                      :class="['m-product-details__swatch', (fakeSKUIndex[0]==index || (fakeSKUIndex[0] == -1 && realSKUIndex[0] == index)) ? 'selected' : '']"
                      v-for="(skuItem,index) in detailInfo.skus" :key="index"
                      @click="toSwitchSKU(index, 0)"
                    >
                      <span class="m-product-details__swatch-circle" :style="{background: `#${skuItem.spec_property}`}"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <!-- 数量 & 价格 -->
            <div class="quantity-price">
              <div class="m-product-details__description-short">
                数量： 
                <i class="iconfont add" @click="changeNum('minus')">&#xe691;</i>
                <span class="num">{{count || 1}}</span>
                <i class="iconfont minus" @click="changeNum('plus')">&#xe666;</i>
              </div>
              <div class="m-product-details__description-short">
                <div class="prices m-product-details__prices c-product-tile__price-container">
                  <div class="price c-product-tile__price">
                    <div>
                      <template v-if="originalPrice != sellingPrice">
                        <!-- <div class="strike-through list c-product-tile__price--strike-through c-button--bold">
                          <p class="text--no-margin">
                            <span class="value">￥{{ originalPrice * count | toFixed(2) }}</span>
                          </p>
                        </div> -->
                        <div class="sales c-product-tile__price-sales c-button--bold">
                          <p class="text--no-margin">
                            <span class="value">￥{{ originalPrice * (count||1) | toFixed(2) }}</span>
                          </p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="sales c-product-tile__price-sales c-button--bold">
                          <p class="text--no-margin">
                            <span class="value">￥{{ sellingPrice * (count||1) | toFixed(2) }}</span>
                          </p>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 礼盒详情区域： collection || collection_sku -->
            <template v-if="type == 'collection' || type == 'collection_sku'">
              <div class="attribute m-product-details__variation-attribute">
                <div class="m-product-set__items">
                  <template v-if="type=='collection_sku'">
                    <div class="m-product-set__item ms-row" v-for="(item, index) in detailInfo.products" :key="index">
                      <div class="col-xs-3">
                        <img :src="item.kv_image" :alt="item.product_name" />
                      </div>
                      <div class="col-xs-9">
                        <div class="m-product-set__item-name">{{item.product_name}}</div>
                        <div class="ms-row">
                          <div class="col-xs-7">
                            <!-- <div class="m-product-details__selected-color">{{item.display_type | classify }}： {{currentSKUItems[index].spec_desc}}</div> -->
                            <div class="m-product-details__selected-color">{{item.display_type | classify }}： {{item.skus[0].spec_desc}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="m-product-set__item ms-row" v-for="(item, index) in detailInfo.products" :key="index">
                      <div class="col-xs-3">
                        <template v-if="currentSKUItems[index] && (currentSKUItems[index].pc_kv_images.length || currentSKUItems[index].kv_images.length)">
                          <img :src="currentSKUItems[index].pc_kv_images[0].url || currentSKUItems[index].kv_images[0].url" :alt="item.product_name" />
                        </template>
                        <template v-else-if="item.skus[0].pc_kv_images.length || item.skus[0].kv_images.length">
                          <img :src="item.skus[0].pc_kv_images[0].url || item.skus[0].kv_images[0].url" :alt="item.product_name" />
                        </template>
                      </div>
                      <div class="col-xs-9 color-vessel">
                        <div class="m-product-set__item-name">{{item.product_name}}</div>
                        <div class="ms-row">
                          <div class="col-xs-9">
                            <div class="m-product-details__selected-color" v-if="item.display_type">
                              {{item.display_type | classify }}： 
                              <span v-if="item.display_type == 'color'" class="color-value" :style="{background: `#${currentSKUItems[index].spec_property}`}"></span>
                              {{currentSKUItems[index].spec_desc}}
                            </div>
                          </div>
                        </div>
                        <div v-if="item.display_type">
                          <i class="iconfont edit" @click="toggleSKUOptions(index, type)">&#xe684;</i>
                          <!-- PC端 - 自由组合套装SKU编辑区域 -->
                          <div class="color-list show-for-md" v-show="showSKUOptions[index]">
                            <VueScroll :ops="vsOpts">
                              <ul :class="[item.display_type+'_list_ul']">
                                <li
                                  v-for="(skuItem, skuIndex) in item.skus" :key="skuIndex"
                                  :class="['color-li', (fakeSKUIndex[index] == skuIndex || (fakeSKUIndex[index] == -1 && realSKUIndex[index] == skuIndex)) ? 'selected' : '']"
                                  @click="toSwitchSKU(skuIndex, index)"
                                >
                                  <div class="m-product-details__swatch">
                                    <span class="m-product-details__swatch-circle" :style="{background: `#${skuItem.spec_property}`}"></span>
                                  </div>
                                  <span>{{skuItem.spec_desc}}</span>
                                </li>
                              </ul>
                            </VueScroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            
            <template v-if="giftList.length">
              <div class="gift-content">
                <div class="title">尊宠礼遇</div>
                <ul>
                  <li class="li" v-for="(item, index) in giftList" :key="index">
                    <div class="name">{{ item.product_name }}</div>
                    <div class="num">x{{ item.qty }}</div>
                  </li>
                </ul>
              </div>
            </template>
            
            <!-- 加入购物车 -->
            <div class="m-product-details__add-to-cart">
              <div class="c-product-tile__actions-wrapper">
                <template v-if="detailInfo && detailInfo.unique_id">
                  <button
                    class="add-to-cart js-add-to-cart-button c-button c-button--primary"
                    @click="addToCart" :disabled="disabledAddToCart"
                  >{{ disabledAddToCart ? "已售罄" : "加入购物车" }}</button>
                </template>
                <template v-else>
                  <button class="add-to-cart js-add-to-cart-button c-button c-button--primary">加入购物车</button>
                </template>
              </div>
              <div class="c-product-tile__actions-wrapper">
                <button class="buy-with-loyalty c-button c-button--secondary" @click="buyNow" :disabled="disabledBuyNow">立即购买</button>
              </div>
            </div>
            <!-- option弹框 -->
            <div class="modal-background" v-if="skuOptions && skuOptions.skus">
              <div :class="['select-list', `${skuOptions.type}__list`]">
                <div class="select-title">选择-产品{{ skuOptions.type == 'color' ? '色号' : '规格' }}</div>
                <div class="c-button c-button--rounded close-icon" @click="closeSKUDialog">
                  <i class="iconfont">&#xe615;</i>
                </div>
                <div class="item-skus__list">
                  <VueScroll :ops="vsOpts">
                    <ul>
                      <li
                        :class="[skuOptions.type == 'color' ? 'color-li' : 'capacity-li']"
                        v-for="(skuItem, index) in skuOptions.skus" :key="index"
                        @click="setFakeSKUIndex(index, skuOptions.itemIndex)"
                      >
                        <div class>
                          <div
                            v-if="skuOptions.type=='color'"
                            :class="['option-swatch', (fakeSKUIndex[skuOptions.itemIndex]==index || (fakeSKUIndex[skuOptions.itemIndex] == -1 && realSKUIndex[skuOptions.itemIndex] == index)) ? 'selected' : '']"
                          >
                            <span class="option-swatch-circle" :style="{background:`#${skuItem.spec_property}`}"></span>
                          </div>
                          <span>{{ skuItem.spec_desc }}</span>
                        </div>
                        <i class="iconfont">{{ (fakeSKUIndex[skuOptions.itemIndex]==index || (fakeSKUIndex[skuOptions.itemIndex] == -1 && realSKUIndex[skuOptions.itemIndex] == index)) ? '&#xe640;' : '&#xe60f;' }}</i>
                      </li>
                    </ul>
                  </VueScroll>
                </div>
                <template v-if="skuOptions.skus[fakeSKUIndex[skuOptions.itemIndex]] && skuOptions.skus[fakeSKUIndex[skuOptions.itemIndex]].stock <= 0">
                  <button class="c-button c-button--primary hide-for-md" disabled>已售罄</button>  
                </template>
                <template v-else>
                  <button class="c-button c-button--primary hide-for-md" @click="setRealSKUIndex">确定</button>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-8 detail-left detail-left_media" v-if="Array.isArray(detailInfo.product_detail) && detailInfo.product_detail.length">
          <div class="image-wrapper">
            <template v-for="(item, index) in detailInfo.product_detail">
              <template v-if="item.tag == 'image' && item.data && item.data.src">
                <img class="pdp-detail-image__item" :src="item.data.src" :alt="detailInfo.product_name" :key="`Item-Img-${index}`" @load="onImageLoaded" @click="actionHandler(item.action)" />
              </template>
              <template v-else-if="item.tag == 'image' && item.src && (item.src.pc || item.src.h5)">
                <img class="pdp-detail-image__item show-for-md" :src="item.src.pc" :alt="detailInfo.product_name" :key="`Item-Img-PC-${index}`" @load="onImageLoaded" @click="actionHandler(item.action)" />
                <img class="pdp-detail-image__item hide-for-md" :src="item.src.h5" :alt="detailInfo.product_name" :key="`Item-Img-H5-${index}`" @load="onImageLoaded" @click="actionHandler(item.action)" />
              </template>
              <template v-else-if="item.tag == 'video' && item.video">
                <VideoWrap :vSrc="item.video" :iSrc="item.src" :showControls="true" :key="`Item-V-${index}`" />
              </template>
              <template v-else-if="item.tag == 'multi_image' && Array.isArray(item.nodes) && item.nodes.length">
                <template v-for="(multiItem, multiIndex) in item.nodes">
                  <img class="pdp-detail-image__item" :src="multiItem.src" :alt="detailInfo.product_name" :key="`Item-MultiImage-${index}-${multiIndex}`" @load="onImageLoaded" @click="actionHandler(multiItem.action)" />
                </template>
              </template>
              <template v-else-if="item.tag == 'product_recommend' && Array.isArray(item.nodes) && item.nodes.length">
                <div class="pdp-recommends" :key="`Item-Recommend-${index}`" >
                  <div class="pdp-recommend__item" v-for="(recItem, recIndex) in item.nodes" :key="`Item-RecItem-${index}-${recIndex}`">
                    <img class="pdp-recommend__item-image" :src="recItem.src" @click="actionHandler(recItem.action)" @load="onImageLoaded" />
                  </div>
                </div>
              </template>
              <template v-else-if="item.tag == 'product_detail_multi_part_text'">
                <ProductDetailMultiPartText :config="item" :key="`Item-Cmp-${index}`"/>
              </template>
              <template v-else-if="item.tag == 'product_detail_title_desc'">
                <ProductDetailTitleDesc :config="item" :key="`Item-Cmp-${index}`"/>
              </template>
              <template v-else-if="item.tag == 'product_detail_text'">
                <ProductDetailText :config="item" :key="`Item-Cmp-${index}`"/>
              </template>
              <template v-else>-</template>
            </template>
          </div>
        </div>
        </div>
      </div>
      <div class="layout">
        <div class="ms-row">
          <div class="col-xs-12 extra-recommend">
            <div class="module-header">
              <IconTitle :config="{title:'热销星品'}" />
            </div>
            <div class="module-body">
              <Recommend region="pdp_rec" :gid="$route.query.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReceiveCoupons v-if="showCouponsList" :unique_id="detailInfo.unique_id" :cats="detailInfo.cats" @onClose="showCouponsList = false"></ReceiveCoupons>
  </div>
</template>

<script>
import PDPSwiper from "@/components/PDPSwiper";
import 'vuescroll/dist/vuescroll.css';
import VueScroll from 'vuescroll/dist/vuescroll-native';
import IconTitle from '@/components/IconTitle.vue';
import VideoWrap from '@/components/VideoWrap.vue';
import Recommend from '@/components/Recommend.vue';
import ProductDetailMultiPartText from '@/components/ProductDetailMultiPartText';
import ProductDetailTitleDesc from '@/components/ProductDetailTitleDesc';
import ProductDetailText from '@/components/ProductDetailText';
import ReceiveCoupons from '@/components/ReceiveCoupons';
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils/index";
import actionMixins from "@/utils/action.mixins";
import QRcode from "qrcode";

export default {
  name: 'ProductDetailPage',
  mixins: [actionMixins],
  components: {
    Breadcrumb: () => import("@/components/Breadcrumb"), VueScroll, PDPSwiper,
    IconTitle, Recommend, VideoWrap,
    ProductDetailMultiPartText, ProductDetailTitleDesc, ProductDetailText, ReceiveCoupons
  },
  data() {
    return {
      vsOpts: {
        bar: {
          background: '#F6F6F6'
        }
      },
      infoPos: "",
      type: "", // PDP 类型
      showSKUOptions: [false], // SKU选择弹层显示状态
      fakeSKUIndex: [-1], // 选中的SKU下标
      realSKUIndex: [-1],
      skuOptions: null, // 当前配置的SKU数据: { itemIndex: 0, skus: [] }
      detailInfo: {},
      bottomHeight: 0,
      count: 1,
      enableFav: true,
      isCollected: false,
      pdpCoupns: [],
      showCouponsList: false,
      liveInfo: {},
      jumpUrl: '',
      giftList: []
    };
  },
  created() {
    const { id } = this.$route.query;
    if (!id) {
      this.$router.replace("/");
      return
    }
    this.onPageScroll = utils.throttle(this.onPageScroll, 100);
	window.sessionStorage.removeItem("qiyu_good_info")
    this.getDetail();
    this.initEvent();
    this.getLiveInfo();
    this.getGift();
  },
  mounted() {
  },
  methods: {
    getDetail() {
      api[types.GOODS_INFO]({ ids: this.$route.query.id }).then(res => {
        if (res.code == 1) {
          let info = res.data[0];
          if (!info) {
            this.$toast({ message: "商品不存在或者已经下架", iconCls: "failure" });
            this.$router.replace({ path: "/" });
            return false;
          }
          this.detailInfo = info;
          this.type = info.display_type;
          this.initCollected();
          // 
          let root = this.detailInfo?.priority_cat_tree?.[0]?.id;
          if (root) {
            this.$store.commit('toggleNavType', root != 107);
          }
          // 
          this.initSKU();
		 this.qiyuGoodSend()
          // 
          let title = this.detailInfo.product_name;
          if (this.detailInfo?.priority_cat_tree?.length) {
            title += ' - ' + Array.from(this.detailInfo.priority_cat_tree).reverse().map(item => item.cat_name).join(" - ")
          }
          let seoInfo = utils.seoMapping(this.detailInfo.unique_id);
          utils.setPageInfo(`${title} - Sisley Paris`, {
            keywords: seoInfo?.kw || this.detailInfo.custom_keyword || this.detailInfo.product_name,
            description: seoInfo?.desc || this.detailInfo.short_product_desc
          });
          // PC时才有该效果
          if (this.winW >= 1024 && Array.isArray(this.detailInfo?.product_detail) && this.detailInfo?.product_detail?.length) {
            this._imageCount = this.detailInfo.product_detail.reduce((prevSize, currItem) => {
              let currSize = 0;
              if (currItem.tag == 'multi_image' || currItem.tag == 'product_recommend') {
                currSize = currItem.nodes.length
              } else if (currItem.tag == 'image') {
                currSize = 1;
              }
              return prevSize + currSize;
            }, 0);
            // 有商品详情，但不是图片
            if (this._imageCount == 0) this.$nextTick(() => {
              this.initScroll();
            });
          }
          // 
          if (this.isLogin) this.addFootPoint();
          // 
          this.report4Browser(this.$route.query.id);
          //
          utils.bdTracker('view_product', this.getPdtTrackInfo());
          this.getPdpCoupons()
		  
		  
        } else {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 初始化SKU选项
    initSKU() {
      // 初始化SKU编辑标记数组
      if (!Array.isArray(this.showSKUOptions)) this.showSKUOptions = [];
      this.showSKUOptions.length = /collection/i.test(this.type) ? this.detailInfo.products.length : 1;
      this.showSKUOptions.fill(false);
      // 默认选中有库存的SKU项，否则选择第一项
      if (this.type == "collection" || this.type == "collection_sku") {
        this.detailInfo.products.forEach((item, index) => {
          this.$set(this.fakeSKUIndex, index, -1);
          this.$set(this.realSKUIndex, index, this.findSKUIndexWithStock(item.skus, 0));
        });
      } else {
        this.$set(this.fakeSKUIndex, 0, -1);
        this.$set(this.realSKUIndex, 0, this.findSKUIndexWithStock(this.detailInfo.skus, 0));
      }
    },
    // 查找有库存的SKU下标
    findSKUIndexWithStock(skus, defaultIndex) {
      let ret = defaultIndex;
      if (Array.isArray(skus) && skus.length > 1) {
        let idx = skus.findIndex(sku => sku.stock > 0);
        ret = idx == -1 ? defaultIndex : idx;
      }
      return ret;
    },
    // 
    initCollected() {
      let matched = this.$store.state.favPids.filter(item => item == this.detailInfo?.unique_id);
      this.isCollected = matched.length > 0;
    },
    // 滚动处理
    initScroll() {
      let infoBox = document.querySelector(".info-box");
      let target = document.querySelector(".extra-recommend");
      if (!infoBox || !target) return false;
      let infoBoxRect = infoBox.getBoundingClientRect();
      let winH = window.innerHeight;
      //  
      this.scrollInfo = { infoBox, infoBoxRect, target, winH };
      // 
      window.addEventListener('scroll', this.onPageScroll, false);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", this.onPageScroll, false);
      });
    },
    // eslint-disable-next-line no-unused-vars
    onPageScroll(isLast) {
      this.renderScroll();
      this.scrollTimer && clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.renderScroll();
      }, 500);
    },
    renderScroll() {
      let { infoBox, infoBoxRect, target, winH } = this.scrollInfo;
      let st = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      let clsName = infoBox.className;
      let rect = target.getBoundingClientRect();
      if (rect.top < winH) {
        this.infoPos = "absolute";
        infoBox.style.setProperty("bottom", winH - infoBoxRect.height -70 + 'px');
        !/absolute/.test(clsName) && (infoBox.className = clsName.replace(/(^\s*)|(\s*$)/g, '').replace(/\s+/g, ' ').replace("fixed", "") + " absolute");
        // console.info('abs');
      } else if (st >= 133) {
        this.infoPos = "fixed";
        infoBox.style.removeProperty("bottom");
        !/fixed/.test(clsName) && (infoBox.className = clsName.replace(/(^\s*)|(\s*$)/g, '').replace(/\s+/g, ' ').replace("absolute", "") + " fixed");
        // console.info('fix');
      } else {
        this.infoPos = "";
        infoBox.className = clsName.replace(/absolute|fixed/, "");
        // console.info('remove fix & abs', st);
      }
    },
    // 
    onImageLoaded() {
      this._imageLoadedCount = (this._imageLoadedCount || 0) + 1;
      if (this._imageLoadedCount == this._imageCount) this.initScroll();
    },
    // 外部点击事件处理
    initEvent() {
      document.addEventListener("click", this.closePopup, false);
      this.$once("hook:beforeDestroy", () => {
        document.removeEventListener("click", this.closePopup, false);
      });
    },
    // 关闭规格选择弹窗
    closePopup(evt) {
      let dom = evt.target || evt.srcElement;
      //
      if (
        dom.classList.contains("edit") ||
        utils.closest(dom, ".color-list") || utils.closest(dom, ".c-select")) {
        return false;
      } else {
        let size = 0;
        if (this.detailInfo.display_type == "collection") {
          size = this.detailInfo.products.length;
        } else {
          size = 1;
        }
        this.showSKUOptions.length = size;
        for (let i = 0; i < size; i++) {
          this.$set(this.showSKUOptions, i, false);
        }
      }
    },
    // 切换PC端SKU选择弹窗显示状态(H5端只有自由组合套装的编辑SKU会进入)
    toggleSKUOptions(index, displayType) {
      if (utils.isMobile() || utils.isWXBrowser()) {
        this.skuOptions = {
          itemIndex: index,
          type: /collection/.test(displayType) ? this.detailInfo.products[index].display_type : this.detailInfo.display_type,
          skus: /collection/.test(displayType) ? this.detailInfo.products[index].skus : this.detailInfo.skus
        }
      } else {
        this.showSKUOptions.forEach((skuOptionItem, skuOptionIndex) => {
          this.$set(this.showSKUOptions, skuOptionIndex, skuOptionIndex == index ? !this.showSKUOptions[index] : false);
        });
      }
    },
    // 关闭H5端SKU选择弹窗
    closeSKUDialog() {
      let { itemIndex } = this.skuOptions;
      this.$set(this.fakeSKUIndex, itemIndex, -1);
      this.skuOptions = null;
    },
    // 
    getRealSKUInfo() {
      let targetId = -1; // SKU_ID or Unique_ID+SKU1_ID+SKU2_ID+...
      let targetPrice = this.sellingPrice;
      // 组合礼盒
      if (this.type == "collection") {
        targetId = `{{${this.detailInfo.unique_id}}}${this.currentSKUItems.reduce((pre,cur)=>{
          return pre + `{{${cur.sku_id}}}`
        }, '')}`;
      } else if (this.type == "collection_sku") {
        targetId = this.detailInfo.skus[0].sku_id;
      } else if (["capacity_ml", "capacity_g", "color"].indexOf(this.type) != -1) {
        // 正常商品 & 固定礼盒
        targetId = this.currentSKUItems[0].sku_id;
      } else {
        // TODO:: 特殊商品 => 梳子
        targetId = this.currentSKUItems[0].sku_id;
      }
      return { targetId, targetPrice };
    },
    // 
    toSwitchSKU(index, suitIndex) {
      this.$set(this.fakeSKUIndex, suitIndex, -1);
      this.$set(this.realSKUIndex, suitIndex, index);
      this.skuOptions = null;
      this.showSKUOptions.fill(false);
    },
    // 设置选中的SKU
    setFakeSKUIndex(index, suitIndex) {
      this.$set(this.fakeSKUIndex, suitIndex, index);
    },
    // 设置选中的SKU
    setRealSKUIndex() {
      // TODO:: 特殊商品 => 梳子
      if (this.type == "capacity_ml" || this.type == "capacity_g" || this.type == "color" || this.type == "collection_sku" || !this.type) {
        this.fakeSKUIndex[0] != -1 && (this.$set(this.realSKUIndex, 0, this.fakeSKUIndex[0]));
        this.$set(this.fakeSKUIndex, 0, -1);
      } else {
        let suitIndex = this.skuOptions.itemIndex;
        this.$set(this.realSKUIndex, suitIndex, this.fakeSKUIndex[suitIndex]);
        this.$set(this.fakeSKUIndex, suitIndex, -1);
      }
      this.skuOptions = null;
    },
    // 
    changeNum(type) {
      if (type == "plus") {
        if (this.count < this.maxStock) {
          this.count++;
        }
      } else {
        if (this.count > 1) {
          this.count--;
        }
      }
    },
    // 加入购物车前置处理
    addToCart() {
      let { targetId, targetPrice } = this.getRealSKUInfo();
      this.realAddToCart(targetId, targetPrice);
    },
    // 加入购物车
    realAddToCart(targetId, targetPrice) {
      if (targetId == -1) return false;
      // console.info(`加购：ID=${targetId},数量=${this.count}`);
      if (this.isLogin) {
        api[types.CART_ADD]({
          id: targetId,
          quantity: this.count
        }).then(res => {
          let { code, data } = res;
          if (code == 1) {
            this.toSyncCartInfo(data);
            // 
            utils.bdTracker('add_to_cart', Object.assign(this.getPdtTrackInfo(), { product_quantity: this.count }));
            utils.bdTracker('start_buy');
          } else if (code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      } else {
        utils.addToCart(
          {
            id: targetId,
            quantity: this.count,
            price: targetPrice
          },
          (localCart, errMsg) => {
            this.toSyncCartInfo(localCart, errMsg);
          }
        );
      }
      // 
      this.report4AddToCart(this.$route.query.id);
    },
    // 更新购物车信息
    toSyncCartInfo(data, errMsg) {
      this.ylTrackPDP('addtocart');
      this.$store.dispatch(types.CART_GET, () => {
        this.$toast({ message: errMsg || "加购成功", iconCls: errMsg?"failure":"success" });
      });
    },
    // 立即购买前置处理
    buyNow() {
      let { targetId, targetPrice } = this.getRealSKUInfo();
      this.realBuyNow(targetId, targetPrice);
    },
    // 立即购买
    realBuyNow(targetId, targetPrice) {
      if (targetId == -1) return false;
      console.info(`购买：ID=${targetId},数量=${this.count}`);
      if (this.isLogin) {
        api[types.CART_ADD]({
          id: targetId,
          quantity: this.count
        }).then(res => {
          let { code } = res;
          if (code == 1) {
            this.toSyncCartAndEnter();
            // 
            utils.bdTracker('buy_now', Object.assign(this.getPdtTrackInfo(), { product_quantity: this.count }));
            utils.bdTracker('start_buy');
          } else if (code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      } else {
        utils.addToCart({
          id: targetId,
          quantity: this.count,
          price: targetPrice
        }, (localCart, errMsg) => {
          this.toSyncCartAndEnter(errMsg);
        });
      }
      // 
      this.report4AddToCart(this.$route.query.id);
    },
    // 
    toSyncCartAndEnter(errMsg) {
      this.ylTrackPDP('addtocart');
      errMsg && this.$toast({ message: errMsg, iconCls: "failure" });
      this.$store.dispatch(types.CART_GET, () => {
        this.$router.push({ path: "/cart" });
      });
    },
    // 切换收藏状态
    toggleFav() {
      if (this.isLogin) {
        let xhrTypes = types.FAV_ADD;
        if (this.isCollected) {
          xhrTypes = types.FAV_DEL;
        }
        api[xhrTypes]({
          pid: this.detailInfo.unique_id,
          type: /collection/i.test(this.detailInfo.display_type) ? 2 : 1
        }).then(res => {
          if (res.code == 1) {
            this.syncFavPids();
            if (xhrTypes == types.FAV_ADD) {
              this.ylTrackPDP('favorite');
              // 
              utils.bdTracker('add_to_list', this.getPdtTrackInfo());
            }
          } else if (res.code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      } else {
        this.$store.commit('toggleLogin', true);
      }
    },
    // 同步已收藏的商品数据
    syncFavPids() {
      this.$store.dispatch(types.FAV_PIDS_LIST);
    },
    // 添加足迹
    addFootPoint() {
      api[types.FOOTPRINT_ADD]({
        pid: this.detailInfo.unique_id,
        type: /collection/i.test(this.detailInfo.display_type) ? 2 : 1
      }).then(res => {
        if (res.code != 1 && res.code != 2) this.$toast({ message: res.message, iconCls: "failure" });
      }).catch(err => {
        console.warn(err);
      });
    },
    // 浏览上报
    report4Browser(id) {
      api[types.REPORT_BROWSER_PDP]({ product_id: id}).then(res => {
        if (res.code != 1) {
          console.warn('[REPORT_BROWSER_PDP]: ', res);
        }
      });
    },
    // 加购上报
    report4AddToCart(id) {
      api[types.REPORT_ADD_TO_CART]({ product_id: id}).then(res => {
        if (res.code != 1) {
          console.warn('[REPORT_ADD_TO_CART]: ', res);
        }
      });
    },
    // GTM
    gtmTrackProduct(isMaster) {
      if (isMaster == undefined) isMaster = this.$store.state.isMaster;
      if (!window.dataLayer) return false;
      window.dataLayer.push({
        siteCountry: 'CN',
        siteLanguage: 'CN',
        pageCategory: isMaster ? 'Product_Page' : 'Product_Page_Hair_rituel'
      });
      let { targetId, targetPrice } = this.getRealSKUInfo();
      window.dataLayer.push({
        ecommerce: {
          impressions: [],
          detail: {
            id: targetId,
            name: this.detailInfo.product_name + (this.type == 'color' && this.currentSKUItems[0] ? ' ' + this.currentSKUItems[0].spec_desc : ''),
            price: targetPrice,
            productDescription: this.detailInfo.product_desc,
            brand: this.detailInfo?.priority_cat_tree?.[0]?.cat_name || '',
            category: this.detailInfo?.priority_cat_tree?.[1]?.cat_name || '',
            variant: this.detailInfo?.priority_cat_tree?.[2]?.cat_name || '',
            productType: ['collection', 'collection_sku'].indexOf(this.type) != -1 ? 'bundle' : this.detailInfo?.skus?.length > 1 ? 'configured' : 'simple'
          }
        }
      });
    },
    // 品数监测# 加购 & 收藏
    ylTrackPDP(type) {
      if (window?.YLTrackerz?.track) {
        let { targetId } = this.getRealSKUInfo();
        window.YLTrackerz.track({
          type: type,
          sku: targetId,
          price: this.sellingPrice,
          quantity: this.count,
          product: this.detailInfo.product_name,
          category: this.detailInfo.priority_cat_tree.map(item => item.cat_name).join(','),
          brand: '希思黎',
          pid: this.detailInfo.product_id,
          uid: this.$store?.state?.userInfo?.id || ''
        });
      }
    },
    // 轮播切换
    onSwiperChange(instance) {
      if (instance && Array.isArray(this.kvImages) && this.kvImages[instance.realIndex]) {
        this.enableFav = this.kvImages[instance.realIndex]?.tag != 'video';
      }
    },
    getPdtTrackInfo() {
      const { unique_id, product_name, priority_cat_tree } = this.detailInfo;
      return {
        product_id: unique_id,
        product_name: product_name,
        product_sku: this.currentSKUItems?.[0].sku_id,
        product_category: priority_cat_tree?.[priority_cat_tree.length-1]?.cat_name
      };
    },
    getPdpCoupons() {
      const { unique_id, cats } = this.detailInfo;
      api[types.PDP_COUPONS]({
        unique_id: unique_id,
        cats: cats.join(',')
      }).then(res => {
        let { code, data } = res;
        if (code == 1) {
          this.pdpCoupns = data;
        }
      })
    },
    handleOpenCouponList() {
      if(this.isLogin) {
        this.showCouponsList = true;
      } else {
        this.$store.commit("toggleLogin", true);
      }
    },
      /**
   * 获取直播间信息
   */
    getLiveInfo() {
      api[types.GET_LIVE_INFO]().then(res => {
        let { code, data } = res;
        if (code == 1) {
          this.liveInfo = data;
          this.getLiveCode();
        }
      })
    },
    getLiveCode() {
      let path =  encodeURIComponent(`pages/pdt-detail/pdt-detail?code=${this.$route.query.id}`)
      let env = process.env.NODE_ENV === 'production' ?  'release' : 'trial'
      this.jumpUrl = `${process.env.VUE_APP_API_PATH}/member/wx/generateUrlLink?path=${path}&env=${env}`
      console.log(this.jumpUrl)
      this.$nextTick(() => {
        QRcode.toCanvas(
          this.$refs.qrcodeCanvas,
          this.jumpUrl,
          {
            width: 128,//自定义宽度
          }
        );
      })
    },
    handleGoWmpDetail() {
      if(utils.isMobile()) {
        window.open(this.jumpUrl);
      }
    },
    /** 获取赠品 */
    getGift(id) {
      api[types.GET_ADDITIONAL_GIFT]({spuId: this.$route.query.id}).then(res => {
        let { code, data } = res;
        if (code == 1) {
          this.giftList = data;
        }
      })
    },
    /**七鱼商品小卡 */
	qiyuGoodSend(){
		let qiyu_good_info={...this.detailInfo}
		if(this.originalPrice != this.sellingPrice){
			qiyu_good_info.originalPrice= this.originalPrice
		}else{
			
			qiyu_good_info.originalPrice=this.sellingPrice
		}
		console.log(qiyu_good_info.originalPrice)
		window.sessionStorage.setItem("qiyu_good_info",JSON.stringify(qiyu_good_info))
	}
  },
  
  computed: {
    isMobile() {
      return utils.isMobile();
    },
    identity() {
      if (this.currentSKUItems) {
        return this.currentSKUItems.map(skuItem => skuItem.sku_id).join("_");
      } else {
        return Date.now();
      }
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    // 是否收藏
    // isCollected() {
    //   console.log(111, this.$store.state?.favPids)
    //   return this.$store.state?.favPids?.indexOf(this.detailInfo?.unique_id) != -1;
    // },
    // 选中的SKU
    currentSKUItems() {
      if (this.detailInfo?.product_name) {
        // TODO:: 特殊商品 => 梳子
        if (this.type == "capacity_ml" || this.type == "capacity_g" || this.type == "color" || !this.type) {
          let skuIndex = this.realSKUIndex[0];
          return skuIndex != -1 ? [this.detailInfo?.skus?.[this.realSKUIndex[0]]] : [];
        } else if (this.type == "collection_sku") {
          // return this.detailInfo?.products?.map((item, index) => item?.skus?.find((skuItem, skuIndex) => skuIndex == this.realSKUIndex[index]));
          return [this.detailInfo?.skus?.[0]];
        } else if (this.type == "collection") {
          return this.detailInfo?.products?.map((item, index) => item?.skus?.find((skuItem, skuIndex) => skuIndex == this.realSKUIndex[index]));
        } else {
          return [];
        }
      }
      return null;
    },
    // 原价
    originalPrice() {
      // TODO:: 特殊商品 => 梳子
      if (["capacity_ml", "capacity_g", "color"].indexOf(this.type) != -1 || (this.detailInfo?.unique_id && !this.type)) {
        return this.currentSKUItems?.[0]?.ori_price || this.detailInfo.highest_ori_price;
      } else if (this.type == "collection_sku") {
        return this.detailInfo?.lowest_ori_price;
      } else if (this.type == "collection") {
        return this.currentSKUItems?.reduce((previous, current, currentIndex) => {
          let isFreebie = this.detailInfo.products[currentIndex].is_freebie;
          return previous + (isFreebie ? 0 : parseFloat(current?.ori_price||0));
        }, 0);
      } else {
        return 0;
      }
    },
    // 售价
    sellingPrice() {
      // TODO:: 特殊商品 => 梳子
      if (["capacity_ml", "capacity_g", "color"].indexOf(this.type) != -1 || (this.detailInfo?.unique_id && !this.type)) {
        return this.currentSKUItems?.[0]?.price || this.detailInfo.highest_price;
      } else if (this.type == "collection_sku") {
        return this.detailInfo?.lowest_price;
      } else if (this.type == "collection") {
        return this.currentSKUItems?.reduce((previous, current, currentIndex) => {
          let isFreebie = this.detailInfo.products[currentIndex].is_freebie;
          return previous + (isFreebie ? 0 : parseFloat(current?.price||0));
        }, 0);
      } else {
        return 0;
      }
    },
    // 轮播图
    kvImages() {
      // TODO:: 特殊商品 => 梳子
      if (["capacity_ml", "capacity_g", "color"].indexOf(this.type) != -1 || !this.type) {
        return this.currentSKUItems?.[0]?.pc_kv_images || this.currentSKUItems?.[0]?.kv_images || this.detailInfo.kv_images;
      } else if (this.type == "collection_sku") {
        return this.currentSKUItems?.[0]?.pc_kv_images || this.currentSKUItems?.[0]?.kv_images || this.detailInfo.kv_images;
      }
      return this.detailInfo.pc_kv_images || this.detailInfo.kv_images;
    },
    // 最大可购买数量控制
    maxStock() {
      if (this.currentSKUItems?.length) {
        // 找出SKU中库存数量最小的
        let minStock = Math.min(...this.currentSKUItems.map(skuItem => skuItem.stock));
        // 最小不能小于0
        minStock = Math.max(minStock, 0);
        // 最大不能大于6
        return Math.min(minStock, 6);
      } else {
        return 6;
      }
    },
    // 加购按钮状态
    disabledAddToCart() {
      if (!this.currentSKUItems) {
        return true;
      } else {
        // 所选SKU库存大于0
        return !this.currentSKUItems?.every(item => item.stock > 0);
      }
    },
    // 立购按钮状态
    disabledBuyNow() {
      return this.disabledAddToCart;
    },
    // SKU确定按钮
    disabledConfirm() {
      return false;
    },
    // 面包屑
    navItems() {
      let ret = [];
      if (this.detailInfo?.priority_cat_tree?.length) {
        ret = ret.concat(this.detailInfo?.priority_cat_tree?.map(item => {
          return { href: `/category/${item.id}`, text: item.cat_name };
        }));
      }
      ret.push({ text: this.detailInfo.product_name });
      return ret;
    },
    winW() {
      return window.innerWidth;
    },
    liveStyle() {
      return {
        maxWidth: utils.isMobile() ? this.liveInfo.width / 2 + 'px' : this.liveInfo.pc_width + 'px',
        maxHeight: utils.isMobile() ? this.liveInfo.height / 2 + 'px' : this.liveInfo.pc_height + 'px'
      }
    }
  },
  watch: {
    $route() {
      this.getDetail();
    },
    currentSKUItems() {
      // SKU切换时检验库存数量
      if (this.count > this.maxStock) this.count = this.maxStock;
      if (this.maxStock < 1) this.count = 1;
      // 
      this.gtmTrackProduct();
    },
    '$store.state.favPids'() {
      this.initCollected();
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .swiper-navigation-btns { padding: 0; }
::v-deep .swiper-navigation-btns .slider-info { display: none; }
//左边
.detail-left { padding-right: 0; padding-left: 0; }
.detail-left_media { margin-top: 40px; }
.m-product-details__main { padding-top: 50px; }
.m-product-details__primary-images {
  position: relative; padding: 0 20px;
  .carousel {
    position: relative;
    .live-content {
      position: absolute;
      z-index: 2;
      top: 100px;
      right: 40px;
      .icon_content {
        .icon {
          max-width: 56px;
          max-height: 56px;
        }
      }
      .live-code {
        position: absolute;
        top: 66px;
        left: 0;
        background: #fff;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        display: none;
        .code-img {
          width: 128px;
          height: 128px;
          .canvas {
            width: 100%;
            height: 100%;
          }
        }
        .code-tip {
          width: 128px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
        }
      }
      &:hover {
        .live-code {
          display: block;
        }
      }
    }
    & /deep/ .slick-slider { width: 100%; height: 0; padding-bottom: 132.20%; }
    .carousel-item {
      img { width: 100%; height: auto; }
    }
    & /deep/ .swiper-nav-btn__wrap.sides-mode .slick-arrow {
      &, & span, & span svg {
        width: 3.625rem; height: 3.625rem;
      }
    }
  }
  .left-icon { transform: rotate(-180deg); display: block; }
  .left-icon, .right-icon { font-size: 28px; }
  .c-minisite-slider__spinner { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; font-size: 0; }
}
.c-minisite-slider__spinner { overflow: hidden; }
.slick-slider { position: relative; display: block; }
//右边
.add, .minus { border-radius: 50%; text-align: center; font-size: 18px; line-height: 20px; color: #282828; cursor: pointer; user-select: none; }
.num { padding: 0 16px; }
.item-skus__list { height: 300px; overflow: auto; }
.m-product-details__main-info {
  width: 100%; padding-left: 0; padding-right: 0; margin-top: 3rem;
  .m-product-details__badges {
    position: absolute; left: 1.0625rem; top: 3.875rem;
    .c-product-tile__badge {
      font-size: 0.625rem; text-transform: uppercase; letter-spacing: 0.0625rem; margin-bottom: 0.3125rem;
      .c-product-tile__badge-item { border: 0.0625rem solid #8c8c8c; background-color: transparent; padding: 0.125rem 0.3125rem; color: #575757; display: inline; }
    }
  }
  .select-list {
    position: absolute; bottom: 0; z-index: 1;
    min-width: 10.6875rem; width: 100%; padding: 1.875rem; margin-top: 0.3125rem; overflow: auto;
    background: #fff; box-shadow: 0 0 0.625rem 0 #ccc;
    border-top-left-radius: 10px; border-top-right-radius: 10px;
    .capacity-li, .color-li { cursor: pointer; }
    button.hide-for-md { display: block; width: 100%; }
    &.color__list {
      padding: 1.875rem 1.25rem 1.875rem 1.875rem;
      .item-skus__list ul { padding-right: 0.625rem;}
    }
  }
  .select-li {
    display: block; padding: 0.625rem; border-radius: 0.5rem; cursor: pointer;
    &.selected { background-color: #f5f5f5; }
  }
  .color-li {
    display: flex; justify-content: flex-start; align-items: center;
    .iconfont { color: #000; }
  }
  .modal-background .color-li { justify-content: space-between; padding: 0.625rem 0; }
  .capacity-li {
    display: flex; justify-content: space-between; align-items: center; padding: 0.625rem 0; border-bottom: 1px solid #dcdcdc;
    .iconfont { color: #000; }
  }
  .close-icon { width: 1.5rem; height: 1.5rem; line-height: 1.4rem; text-align: center; display: block; position: absolute; right: 1.25rem; top: 1.25rem; }
  .m-product-details__slider-separator { width: 4.0625rem; height: 0; border: none; border-top: 0.1875rem solid hsla(0, 0%, 87.1%, 0.5); margin: 0.5625rem auto; }
  .attribute { margin: 0 1.0625rem 0.5rem; }
  .m-product-details__product-name {
    margin: 0 1.0625rem 0.5rem; max-height: 4.5rem; overflow: hidden;
    &.zh { font-size: 24px; }
    &.en { font-size: 16px; }
  }
  .m-product-details__description-short {
    margin: 0 1.0625rem 0.625rem; max-height: 2rem; overflow: hidden; font-size: 0.875rem; color: #282828;
    display: flex; justify-content: flex-start; align-items: flex-start;
    &.pdp__desc { max-height: none; }
  }
  .top-xs { align-items: flex-start; }
  .m-product-details__selected-capacity { margin-left: 1.0625rem; margin-bottom: 0.625rem; font-size: 0.875rem; color: #282828; }
  // .m-product-details__variation-non-swatchable { display: none; }
  .m-product-details__prices {
    &.c-product-tile__price-container { float: none; }
    .c-product-tile__price--strike-through { color: #575757; }
  }
  .c-product-tile__price-container { font-size: 0.75rem; white-space: nowrap; }
  .c-product-tile__price--strike-through { margin-right: 0.625rem; color: #575757; text-decoration: line-through; display: inline-block; }
  .c-product-tile__price-sales { color: #000; display: inline-block; }
  .m-product-details__prices { margin-right: 1.0625rem; }
  .m-product-details__add-to-cart {
    margin: 0 1.0625rem 0.3125rem;
    .c-product-tile__actions-wrapper { margin-top: 0; }
    .c-button { margin-bottom: 1rem; display: block; width: 100%; margin-right: 0; margin-left: 0; max-width: 100%; }
  }
  .c-product-tile__actions-wrapper { margin-top: 0.9375rem; position: relative; z-index: 2; }
  .m-product-details__variation-attribute { margin-bottom: 1.25rem; }
  .m-product-details__variation-item {
    display: inline-block; margin-right: 1.0625rem; font-size: 0.8125rem; color: #575757; text-decoration: none; 
    border-bottom: 0.125rem solid transparent; cursor: pointer;
    &.selected { border-color: #000; }
  }
}
//口红
.m-product-details__swatch {
  align-items: center;
  background: #fff;
  border-radius: 50%;
  border: 0.0625rem solid transparent;
  display: flex;
  float: left;
  cursor: pointer;
  &.selected,
  &:hover {
    border-color: #cacaca;
  }
}
.m-product-details__swatch-circle {
  border-radius: 50%;
  display: block;
  height: 0.9375rem;
  margin-left: 0.9375rem;
  margin-right: 0.9375rem;
  position: relative;
  width: 0.9375rem;
}
.option-swatch {
  padding: 0.15rem;
  margin-right: 1rem;
  background: #fff;
  border-radius: 50%;
  border: 0.0625rem solid transparent;
  display: flex;
  float: left;
  cursor: pointer;
  &.selected,
  &:hover {
    border-color: #cacaca;
  }
}
.option-swatch-circle {
  border-radius: 50%;
  display: block;
  height: 0.9375rem;
  position: relative;
  width: 0.9375rem;
}
.c-select {
  width: 13.125rem; height: 1.875rem; padding: 0 0.625rem; margin-bottom: 0.625rem;
  background: rgba(255, 255, 255, 1); border-radius: 15px; border: 1px solid rgba(213, 213, 213, 1);
  display: flex; justify-content: space-between; align-items: center; cursor: pointer;
}
.slect-color { display: flex; align-items: center; }
.color-value { border-radius: 50%; height: 0.625rem; width: 0.625rem; margin-right: 0.625rem; display: inline-block; }
.color-list {
  width: 14.6875rem; height: 300px; overflow: auto; padding: 1.875rem; box-sizing: border-box; border: 1px solid #ededed; background: #fff; position: absolute; z-index: 3;
  ul { margin: 0; }
}
.color-li {
  display: flex; align-items: center;
  &:hover { cursor: pointer; }
  &:last-child { margin-bottom: 0; }
}
.c-button--icon { border: none; border-radius: 0; padding: 0; }
.m-product-details__wishlist-btn { position: absolute; right: 2.3125rem; top: 1.25rem; z-index: 1; }
// 礼盒
.m-product-set__items {
  margin: 0.625rem 1.0625rem 0.3125rem;
}
.m-product-set__item {
  margin-bottom: 2.1875rem;
  img {
    width: 83px;
    height: auto;
  }
  .m-product-details__prices {
    margin-right: 0;
    margin-bottom: 0.625rem;
    margin-left: 0;
  }
  .m-product-details__selected-color {
    margin-bottom: 0.625rem;
  }
}
.color-vessel {
  position: relative;
}
.select-option {
  position: absolute;
  top: 0;
  left: 0;
}
.edit {
  margin-left: 0.625rem;
  &:hover {
    cursor: pointer;
  }
}
.m-product-set__item-name {
  color: #000;
  font-size: 0.75rem;
  font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
  text-decoration: none;
  display: block;
  margin-bottom: 0.625rem;
}
.quantity-price {
  display: flex; flex-direction: column-reverse; margin-bottom: 2.5rem;
}

.gift-content {
  margin-top: 0.625rem;
  padding: 0 1.0625rem 20px;
  margin-bottom: 2px;
  .title {
    font-weight: 500;
    margin-bottom: 6px;
  }
  .li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

.capacity_ml_list_ul, .collection_g_list_ul, .collection_list_ul, .collection_sku_list_ul {
  .color-li {
    display: inline-block; margin-right: 1rem;
    .m-product-details__swatch { display: none; }
    &.selected { border-bottom: 1px solid #000; }
  }
}
.color_list_ul {
  .color-li {
    &.selected {
      .m-product-details__swatch { border: 1px solid red; }
    }
  }
}
.extra-recommend {
  padding-top: 6rem;
  .module-header { margin-bottom: 2rem; }
  .module-body {
    & /deep/ .recommond-wrap .header { display: none; }
  }
}
.image-wrapper {
  position: relative;
  img { width: 100%; height: auto; }
  .pdp-recommends {
    display: flex;
    .pdp-recommend__item {
      flex: 1;
      .pdp-recommend__item-image { cursor: pointer; }
    }
  }
}
.pdp-coupons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 1.0625rem;
  padding-bottom: 16px;
  cursor: pointer;
  .ul {
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    width: calc(100% - 40px);
    overflow: auto;
    
    .li {
      white-space: nowrap;
      border-radius: 2px;
      border: 1px solid #BA0014;
      padding: 2px 8px;
      color: #BA0014;
      margin-right: 8px;
    }
  }
  .icon {
    flex-shrink: 1;
    line-height: 32px;
    height: 32px;
    .iconfont {
      font-size: 28px;
    }
  }
}
@media screen and (min-width: 48em) {
  .quantity-price {
    flex-direction: row;
    justify-content: space-between;
  }
  .detail-left {
    padding-right: 50px;
  }
  .m-product-details__main {
    padding: 0 3.875rem;
    margin-top: 1.25rem;
    .m-product-details__primary-images {
      position: relative; padding: 0;
      margin-left: 3.5rem;
    }
    .image-wrapper {
      position: relative;
      img { width: 100%; height: auto; }
      .pdp-recommends {
        display: flex;
        .pdp-recommend__item {
          flex: 1; display: flex;
        }
      }
    }
  }
  .m-product-details__main-info {
    padding-bottom: 1.875rem;
    .m-product-details__badges { left: 1.25rem; top: 1.25rem; }
    .m-product-details__product-name, .attribute { margin: 0 0 0.5rem; }
    .m-product-details__description-short { margin: 0 0 0.625rem; }
    .m-product-details__variation-attribute { margin-bottom: 1.25rem; }
    .m-product-details__color-swatches { margin-bottom: 0; }
    .m-product-details__selected-capacity,
    .m-product-details__variation-non-swatchable {
      display: block;
      margin-left: 0;
    }
    .c-product-tile__price-container {
      float: left;
      margin-right: 0.625rem;
    }
    .m-product-details__prices {
      margin-right: 0;
    }
    .m-product-details__add-to-cart {
      margin: 0 0 1.25rem;
      .c-button {
        margin-bottom: 1rem;
      }
    }
    // Fixed 定位
  }
  .m-product-details__wishlist-btn {
    right: 1.25rem;
    bottom: 1.25rem;
  }
  .m-product-details__swatch {
    margin: 0.625rem 0.5rem;
    height: 1.375rem;
    width: 1.375rem;
    justify-content: center;
  }
  .m-product-details__swatch-circle {
    margin: 0;
    height: 1rem;
    width: 1rem;
  }
  .m-product-set__items {
    margin: 0.625rem 0 0.3125rem;
  }
  .m-product-set__item {
    .m-product-details__prices {
      margin-right: 0;
    }
  }
  .pdp-coupons {
    margin: 0;
  }
}
@media screen and (min-width: 64em) {
  .pdp-wrap /deep/ .breadcrumb { padding: 0 1.875rem; }
  .detail-left_media { margin-top: 100px; }
  .m-product-details__main-info {
    margin-top: 0;
    .m-product-details__product-name {
      &.zh { font-size: 16px; }
      &.en { font-size: 15px; }
    }
    .info-box {
      width: 400px; max-width: 400px; z-index: 9;
      &.dialog__show { z-index: 11; }
      &.fixed {
        position: fixed; top: 70px;
        .m-product-details__add-to-cart {
          margin: 0;
          .buy-with-loyalty { margin-bottom: 0; }
        }
      }
      &.absolute {
        position: absolute;
      }
    }
  }
  .detail-left { width: 66.66666667%; min-height: 1px; }
  ::v-deep .swiper-navigation-btns .slick-arrow {
    display: block; width: 60px; height: 60px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #fff;
    z-index: 1;
    &:hover { background-color: #000; }
    &.carousel__btn--prev { left: 0; transform: translateX(-50%) translateY(-50%); }
    &.carousel__btn--next { right: 0; transform: translateX(50%) translateY(-50%); }
  }
  .m-product-details__main {
    padding: 0 1.875rem;
    margin-top: 0;
    .m-product-details__primary-images {
      margin: 0 auto; width: 590px;
      .carousel {
        .carousel-item {
          // background: #F6F6F6;
          img { width: 100%; max-width: 590px; height: auto; margin: 0 auto; display: block; }
        }
      }
    }
  }
  .m-product-details__main-info {
    .m-product-details__badges {
      position: static;
      margin-bottom: 0.625rem;
      margin-top: 0.0625rem;
    }

    .c-product-tile__actions-wrapper {
      margin-top: 1.25rem;
    }
    .m-product-details__add-to-cart {
      .c-button {
        margin-bottom: 1rem;
      }
    }
  }
  .m-product-details__wishlist-btn {
    bottom: auto;
    right: 1.875rem;
    top: 1.875rem;
  }
  .m-product-details__swatch {
    margin: 0.625rem 0.4375rem;
    height: 1.5rem;
    width: 1.5rem;
  }
  .m-product-details__swatch-circle {
    height: 1.125rem;
    width: 1.125rem;
  }
}
@media screen and (min-width: 75em) {
  .m-product-details__main {
    padding: 0;
  }
  .m-product-details__main-info {
    padding-bottom: 3.125rem;
  }
  .gift-content {
    padding: 0 0 20px;
  }
}
</style>